import { Dropdown as DropdownComponent } from 'antd';

const Dropdown = props => <DropdownComponent {...props} />;

export default Dropdown;
